 // screens/KlarnaTermsScreen

import React from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "react-bootstrap";

const KlarnaTermsScreen = () => {
  const { t } = useTranslation();

  return (
    <Container className="pb-3">
      <h3 className="py-4">{t('terms_conditions_title')}</h3>
      
      <section className="pb-2">
        <h5>{t('purchase_payment_title')}</h5>
        <p>{t('purchase_payment_description')}</p>
      </section>
      
      <section className="pb-2">
        <h5>{t('delivery_policy_title')}</h5>
        <p>{t('delivery_policy_description')}</p>
      </section>
           
      <section className="pb-2">
        <h5>{t('store_customer_responsibilities_title')}</h5>
        <p>{t('store_customer_responsibilities_description')}</p>
      </section>
    </Container>
  );
};

export default KlarnaTermsScreen;
